import { render } from "./addmenu.vue?vue&type=template&id=402aa4a4&scoped=true"
import script from "./addmenu.vue?vue&type=script&lang=js"
export * from "./addmenu.vue?vue&type=script&lang=js"

import "./addmenu.vue?vue&type=style&index=0&id=402aa4a4&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402aa4a4"]])

export default __exports__